import { graphql } from '../graphql';
import { useRequestWithClientId } from '../hooks/useRequest';
const GET_OR_CREATE_SUPPORT_CASE = graphql(`
  mutation GetOrCreateSupportCase(
    $lineOfBusiness: String!
    $language: String
    $flow: String
    $pagesVisited: [String!]!
  ) {
    getOrCreateSupportCase(
      input: {
        lineOfBusiness: $lineOfBusiness
        language: $language
        flow: $flow
        pagesVisited: $pagesVisited
      }
    )
  }
`);
export const useGetOrCreateSupportCaseRequest = (lineOfBusiness, clientId, language) => {
    return useRequestWithClientId(true, lineOfBusiness, clientId, GET_OR_CREATE_SUPPORT_CASE, {
        lineOfBusiness,
        language,
    });
};
